export default {
  ExpenseInvest: 1,
  ExpenseProgram: 2,
  ExpenseRegular: 3,
  ExpenseOther: 4, // Chi khác
  ExpenseBusiness: 5, // Chi từ nguồn HĐSNDV
  ExpenseFees: 6, // Chi phí, lệ phí
  RevenueFees: 7, // Thu phí, lệ phí
  RevenueOther: 8,
  RevenueBudget: 9, // Thu NSNN
  RevenueBusiness: 10, // Thu HĐSN
};